import { React, Component, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Button } from '@digsup/components-button';
import { Icon } from '@digsup/components-icon';
import { Input } from './Input';
import { styles } from './Input.scss';

const cx = classNames.bind(styles);

class SearchComponent extends Component {
  renderSuffix() {
    const { enterButton, onSearch, size } = this.props;

    if (enterButton) return null;

    const suffixIconClasses = cx(
      'c-input-affix__icon',
      'c-input-affix__icon--search',
    );
    const iconProps = {
      className: suffixIconClasses,
      onClick: onSearch,
      key: 'searchIcon',
      role: 'button',
      onMouseDown: e => {
        // Prevent focused state lost
        // https://github.com/ant-design/ant-design/issues/15173
        e.preventDefault();
      },
    };

    const suffixNode = (
      <i {...iconProps}>
        <Icon size={size} name="magnifying-glass" />
      </i>
    );

    return suffixNode;
  }

  renderAddonAfter() {
    const { enterButton, onSearch, size, disabled } = this.props;

    if (!enterButton) return null;

    let buttonNode;
    const buttonProps = {
      onClick: onSearch,
      key: 'enterButton',
      disabled,
      size,
      onKeyDown: e => e.keyCode === 13 && onSearch?.(),
    };

    if (enterButton === true) {
      buttonNode = (
        <Button
          {...buttonProps}
          iconOnly
          icon={<Icon size={size} name="magnifying-glass" />}
        />
      );
    } else {
      buttonNode = <Button {...buttonProps}>{enterButton}</Button>;
    }

    return buttonNode;
  }

  render() {
    const { forwarderRef, onSearch, ...props } = this.props;
    return (
      <Input
        ref={forwarderRef}
        onKeyDown={e => e.keyCode === 13 && onSearch?.()}
        addonAfter={this.renderAddonAfter()}
        suffix={this.renderSuffix()}
        {...props}
      />
    );
  }
}

export const Search = React.forwardRef((props, ref) => (
  <SearchComponent {...props} forwarderRef={ref} />
));

Search.propTypes = {
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  /**
   * To show an enter button after input(if true or string will remove suffix search icon)
   */
  enterButton: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /**
   * The callback function that is triggered when user click on the search-icon or enterButton
   */
  onSearch: PropTypes.func,
};

Search.defaultProps = {
  disabled: false,
  size: 'medium',
  enterButton: false,
  onSearch: () => {},
};
